
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.53 10.76H15a6.4 6.4 0 00-5.76-3.62v5.45C6.48 14.31 5.73 17.73 5 21H1.57c0 4.35.32 7.26 4.55 7.46a7 7 0 003.76 3.19v6.85h4.23l2.15-4.1h13.23v4.1h4.23a28.8 28.8 0 004.71-15c0-6.7-4.16-12.78-10.86-12.78h-1.93M9.88 21.62a1.92 1.92 0 013.83 0M17.74 14.96h9.59","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"22.53","cy":"6.61","r":"5.11","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    